import React, { useEffect, useState } from 'react';
import { Clock3Icon, EyeIcon, SparklesIcon } from 'lucide-react';
interface OfferTime {
  day: string;
  hours: string;
  minutes: string;
  seconds: string;
}
function getOfferTime(): OfferTime {
  const now = new Date();
  const tomorrow = new Date(now);
  tomorrow.setHours(24, 0, 0, 0);
  const remaining = Math.max(0, tomorrow.getTime() - now.getTime());
  const totalSeconds = Math.floor(remaining / 1000);
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor(totalSeconds % 3600 / 60);
  const seconds = totalSeconds % 60;
  return {
    day: new Intl.DateTimeFormat('es-AR', {
      weekday: 'long'
    }).format(now).toUpperCase(),
    hours: String(hours).padStart(2, '0'),
    minutes: String(minutes).padStart(2, '0'),
    seconds: String(seconds).padStart(2, '0')
  };
}
export function TodayOfferCard() {
  const [offerTime, setOfferTime] = useState<OfferTime>(getOfferTime);
  useEffect(() => {
    const timer = window.setInterval(() => setOfferTime(getOfferTime()), 1000);
    return () => window.clearInterval(timer);
  }, []);
  return <aside aria-label="Información sobre la oferta disponible hoy" className="mt-4 overflow-hidden rounded-2xl border border-[#C9AA62]/80 bg-slate px-4 py-4 text-white shadow-[0_14px_30px_-18px_rgba(61,61,61,0.8)] ring-1 ring-[#C9AA62]/15 sm:px-5 sm:py-4" data-id="element-214" data-mp="e8jn5toohelx">
      <div className="flex flex-col items-center gap-3 text-center sm:flex-row sm:justify-between sm:gap-5 sm:text-left" data-id="element-215" data-mp="n6lu0pv3f1h4">
        <div className="min-w-0" data-id="element-216" data-mp="3rmwryfl2sdyi">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-[#C9AA62]/50 bg-[#C9AA62]/10 px-2.5 py-1 text-[11px] font-bold tracking-[0.12em] text-[#F5DEA0]" data-id="element-217" data-mp="3rny28hu9owf6">
            <SparklesIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-218" data-mp="4hp2gtr2yn2l" />
            OFERTA DISPONIBLE HOY
          </span>
          <p className="mt-2 text-xs font-medium uppercase tracking-[0.18em] text-white/65" data-id="element-219" data-mp="3cw5yz47qz8tt">
            {offerTime.day}
          </p>
          <p className="mt-1 text-sm leading-snug text-white/85" data-id="element-220" data-mp="37wtayg553vpn">La promoción de hoy cierra a medianoche local.</p>
        </div>

        <div className="flex shrink-0 items-center gap-3" role="timer" aria-live="polite" data-id="element-221" data-mp="1gu2i7rxqrd0z">
          <Clock3Icon className="hidden h-5 w-5 text-[#F5DEA0] sm:block" aria-hidden="true" data-id="element-222" data-mp="1llkiedrxx9kw" />
          <TimeUnit value={offerTime.hours} label="HS" data-id="element-223" data-mp="1qk5lqm2ho9dk" />
          <span className="pb-4 font-serif-display text-2xl font-bold text-[#F5DEA0]" aria-hidden="true" data-id="element-224" data-mp="1qjm3f48xfiz0">:</span>
          <TimeUnit value={offerTime.minutes} label="MIN" data-id="element-225" data-mp="syrk0220wme2" />
          <span className="pb-4 font-serif-display text-2xl font-bold text-[#F5DEA0]" aria-hidden="true" data-id="element-226" data-mp="xwsysasf1zjq">:</span>
          <TimeUnit value={offerTime.seconds} label="SEG" data-id="element-227" data-mp="12t9np77fwhxv" />
        </div>
      </div>

      <div className="mt-3 flex items-center justify-center gap-2 border-t border-white/10 pt-3 text-center text-xs text-white/65 sm:justify-start" data-id="element-228" data-mp="16xhc139zjvvk">
        <EyeIcon className="h-3.5 w-3.5 shrink-0 text-[#F5DEA0]" aria-hidden="true" data-id="element-229" data-mp="2ecchbj0e4cbx" />
        <span data-id="element-230" data-mp="2ido5dk3m8pi0">Revisá la oferta de hoy antes de que termine.</span>
      </div>
    </aside>;
}
interface TimeUnitProps {
  value: string;
  label: string;
}
function TimeUnit({
  value,
  label
}: TimeUnitProps) {
  return <div className="flex min-w-[38px] flex-col items-center" data-id="element-231" data-mp="3u1bypovxkbsk">
      <span className="font-serif-display text-3xl font-bold leading-none text-[#F5DEA0] sm:text-4xl" data-id="element-232" data-mp="3tzr5c2lcqywa">{value}</span>
      <span className="mt-1 text-[10px] font-semibold tracking-[0.13em] text-white/55" data-id="element-233" data-mp="3p04rps1m3gmy">{label}</span>
    </div>;
}